import environment from "environment";
import { Connect } from "./connect";

/**
 * Servicio para aprobar pagos (issuer_payment)
 * Conecta con el endpoint PATCH /api/v2/payments/:id/approve
 */
export class PaymentApprovalConnect extends Connect {
  constructor() {
    const { apiKey, apiMsIntegration, apiUrl } = environment;
    const login = { idToken: sessionStorage.getItem("idToken") };
    super(apiMsIntegration, "", {
      apiKey,
      token: login.idToken,
      Origin: apiUrl
    });
  }

  /**
   * Aprueba un issuer_payment actualizando is_approved a true
   * @param issuerPaymentId - ID del issuer_payment
   * @returns Promise con la respuesta del servidor
   */
  async approvePayment(issuerPaymentId: number): Promise<any> {
    const response: any = await this.request({
      method: "patch",
      service: `acc-integration/api/v2/payments/${issuerPaymentId}/approve`
    });

    return response.data;
  }
}
